"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCloseEvents = exports.closeEvents = void 0;
var AddBackorderDemandEvent = _interopRequireWildcard(require("@ori-events/add-backorder-demand"));
var AddPersonalSubscriptionEvent = _interopRequireWildcard(require("@ori-events/add-personal-subscription"));
var BasketUpdatedEvent = _interopRequireWildcard(require("@ori-events/basket-updated"));
var ReplaceShoppingBagItem = _interopRequireWildcard(require("@ori-events/replace-shopping-bag-item"));
var ReplaceSubscriptionEvent = _interopRequireWildcard(require("@ori-events/replace-subscription"));
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const closeEvents = exports.closeEvents = [AddBackorderDemandEvent.Name, ReplaceShoppingBagItem.Name, ReplaceSubscriptionEvent.Name];
const useCloseEvents = ({
  onClose
}) => {
  const [closeEvent, setCloseEvent] = (0, _react.useState)();
  const onBasketUpdated = (0, _react.useCallback)(() => {
    if (closeEvent) {
      onClose();
      setCloseEvent(undefined);
    }
  }, [closeEvent, onClose]);
  const onAddPersonalSubscription = (0, _react.useCallback)(event => {
    const {
      detail: {
        lineNumber,
        originalQuantity
      }
    } = event;
    if (lineNumber != null && originalQuantity != null) {
      setCloseEvent(event);
    }
  }, []);
  const events = (0, _react.useMemo)(() => [...closeEvents.map(name => ({
    name,
    listener: setCloseEvent
  })), {
    name: AddPersonalSubscriptionEvent.Name,
    listener: onAddPersonalSubscription
  }, {
    name: BasketUpdatedEvent.Name,
    listener: onBasketUpdated
  }], [onAddPersonalSubscription, onBasketUpdated]);
  (0, _presentationHooks.useGlobalEvents)(events);
};
exports.useCloseEvents = useCloseEvents;